export const DEFAULT_PAGE = 0;
export const MIN_PAGINATION_ITEMS = 20;
export const defaultSorted = [{ id: 'sku', asc: true }];
